import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@asad/crane-ui'

import { DEFAULT_VIEW_ID, type DashboardView } from '../model/dashboardViews'

type DashboardViewSelectorProps = {
  value: string
  views: DashboardView[]
  id?: string
  disabled?: boolean
  onChange: (id: string) => void
}

export const DashboardViewSelector = ({ value, views, id, disabled = false, onChange }: DashboardViewSelectorProps) => {
  const { t } = useTranslation()
  const generatedId = useId()
  const selectId = id ?? generatedId

  return (
    <div className='flex min-w-0 items-center gap-2'>
      <Label className='shrink-0 text-xs font-semibold text-crane-muted-foreground' htmlFor={selectId}>
        {t('dashboardViews.activeView')}
      </Label>
      <Select value={value} disabled={disabled} onValueChange={onChange}>
        <SelectTrigger id={selectId} className='h-8 w-crane-select-md max-w-full bg-crane-card-inset'>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={DEFAULT_VIEW_ID}>{t('dashboardViews.defaultView')}</SelectItem>
          {views.map((view) => (
            <SelectItem key={view.id} value={view.id}>
              {view.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
